import { Pipe, PipeTransform } from '@angular/core';
import { ValidationMessage } from '@next/core-lib/cart';
import { LocaleService } from '@next/core-lib/i18n';

import { translateValidationMessages } from '../../store/selectors';

@Pipe({ name: 'formatValidationMessage', standalone: true })
export class FormatValidationMessagePipe implements PipeTransform {
  constructor(private readonly _localeService: LocaleService) {}

  public transform(value: ValidationMessage): string {
    return translateValidationMessages(value, this._localeService)?.message;
  }
}
